module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter has-text-left"
  }, [_c('b-field', {
    staticClass: "article-type",
    attrs: {
      "label": "Тип новости"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "ordinary"
    }
  }, [_vm._v("Обычная")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "important"
    }
  }, [_vm._v("Важная")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "obligatory"
    }
  }, [_vm._v("Обязательная "), _c('br'), _vm._v("  к прочтению")])], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Дата публикации"
    }
  }, [_c('datepicker', {
    attrs: {
      "input-class": "input",
      "language": "ru"
    },
    model: {
      value: (_vm.article.publishDate),
      callback: function($$v) {
        _vm.$set(_vm.article, "publishDate", $$v)
      },
      expression: "article.publishDate"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Название"
    }
  }, [_c('b-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.article.title),
      callback: function($$v) {
        _vm.$set(_vm.article, "title", $$v)
      },
      expression: "article.title"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Текст"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.article.text),
      callback: function($$v) {
        _vm.$set(_vm.article, "text", $$v)
      },
      expression: "article.text"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('b-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "Поиск..."
    },
    on: {
      "change": _vm.filterClientsList
    }
  }), _vm._v(" "), _c('b-checkbox', {
    on: {
      "change": _vm.selectAll
    }
  }, [_vm._v("Выбрать всех")])], 1), _vm._v(" "), _c('div', {
    staticClass: "selection-container"
  }, [_vm._l((_vm.filteredClientsList), function(client) {
    return _c('div', {
      staticClass: "client-item"
    }, [_c('div', {
      staticClass: "client-data"
    }, [_c('p', [_vm._v(_vm._s(client.ClientName))]), _vm._v(" "), _c('p', {
      staticClass: "dbo"
    }, [_vm._v(_vm._s(client.DBO))])]), _vm._v(" "), _c('b-checkbox', {
      on: {
        "change": function($event) {
          return _vm.clientSelected(client)
        }
      },
      model: {
        value: (client.isSelected),
        callback: function($$v) {
          _vm.$set(client, "isSelected", $$v)
        },
        expression: "client.isSelected"
      }
    })], 1)
  }), _vm._v(" "), (_vm.filteredClientsList.length === 0 && this.clients) ? _c('p', {
    staticClass: "has-text-centered is-empty"
  }, [_vm._v("По вашему запросу ничего не найдено")]) : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "button is-fullwidth",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-fullwidth",
    attrs: {
      "to": {
        name: 'Notifications'
      }
    }
  }, [_vm._v("ОТМЕНИТЬ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clients-search"
  }, [_c('h5', {
    staticClass: "has-text-centered"
  }, [_vm._v("Выберите клиентов, которым отправить уведомление")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b31c054"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Editor.vue
// module id = 917
// module chunks = 0